<div *transloco="let t; read:'permit.gasfreeCert'" class="root">
    <div class="root__question-text" [innerHTML]="t('heading')">
    </div>

    <div class="root__choices">
        <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.Yes"
            (click)="select(CustomerQuestionAnswer.Yes)">
            {{ t("yes") }}
        </div>
        <div class="root__choices__item" [class.root__choices__item--active]="currentCustomerAnswer === CustomerQuestionAnswer.No"
            (click)="select(CustomerQuestionAnswer.No)">
            {{ t("no") }}
        </div>
    </div>

    <div *ngIf="currentCustomerAnswer === CustomerQuestionAnswer.Yes" class="root__create">
        <button class="root__create__button" type="button" (click)="createGasfreeCert()">{{ t("create") }}</button>
    </div>

    <div class="root__actions">
        <button class="root__actions__back" type="button" (click)="goBack()">{{ t("back") }}</button>
        <button class="root__actions__continue" type="button" (click)="continue()" [class.root__actions__continue--disabled]="!canProceed">
            {{ t("next") }}
        </button>
    </div>
</div>
